import * as T from '../../constants/boost';

const initialState = {
  messages: [],
  detail: null,
  sending: false,
  sendResult: null,
  customers: [],
  templates: [],
  credit: null,
  settings: null,
  admin: null,
  analytics: null,
  platformConfig: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case T.STORE_BOOST_HISTORY:
      return { ...state, messages: action.messages || [] };
    case T.STORE_BOOST_DETAIL:
      return { ...state, detail: action.detail || null };
    case T.STORE_BOOST_SENDING:
      return { ...state, sending: !!action.sending };
    case T.STORE_BOOST_SEND_RESULT:
      return { ...state, sendResult: action.result || null };
    case T.CLEAR_BOOST_DETAIL:
      return { ...state, detail: null };
    case T.STORE_BOOST_CUSTOMERS:
      return { ...state, customers: action.customers || [] };
    case T.STORE_BOOST_TEMPLATES:
      return { ...state, templates: action.templates || [] };
    case T.STORE_BOOST_CREDIT:
      return { ...state, credit: action.credit || null };
    case T.STORE_BOOST_SETTINGS:
      return { ...state, settings: action.settings || null };
    case T.STORE_BOOST_ADMIN:
      return { ...state, admin: action.admin || null };
    case T.STORE_BOOST_ANALYTICS:
      return { ...state, analytics: action.analytics || null };
    case T.STORE_BOOST_PLATFORM_CONFIG:
      return { ...state, platformConfig: action.platformConfig || null };
    default:
      return state;
  }
};
